@for (toast of toastService.toastsError; track toast) {
<ngb-toast
  class="toast-error"
  [autohide]="true"
  [delay]="toast.delay || 3000"
  (hidden)="toastService.remove(toast)"
>
  @if (isTemplate(toast)) {
  <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
  } @else {
  <mat-icon aria-hidden="false" aria-label="Example add-circle-outline icon">
    add_circle_outline</mat-icon
  >
  Error: {{ toast.textOrTpl }}
  <span class="hoover-button" (click)="toastService.remove(toast)">X</span>
  }
</ngb-toast>
}
